import { FileText, MessageSquare, ShieldCheck } from "lucide-react";
import { ResumePanel } from "./ResumePanel";

/** Resume link plus the three things worth knowing while they answer. */
export const WizardSidebar = ({ sessionId, onContactDirectly }) => (
  <aside className="space-y-4 lg:col-span-4">
    {sessionId ? <ResumePanel sessionId={sessionId} /> : null}

    <div className="tt-card p-5">
      <h3 className="tt-eyebrow">Good to know</h3>
      <ul className="mt-3 space-y-3 text-[13px] leading-relaxed text-muted-foreground">
        <li className="flex items-start gap-2">
          <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden="true" />
          T-TITE is not VAT-registered — no VAT is added to any figure you see.
        </li>
        <li className="flex items-start gap-2">
          <FileText className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden="true" />
          Nothing to upload. You give us the figures, and they're what your price is built from.
        </li>
        <li className="flex items-start gap-2">
          <MessageSquare className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden="true" />
          Rather just talk?{" "}
          <button
            type="button"
            onClick={onContactDirectly}
            className="tt-link text-left"
            data-testid="sidebar-contact-directly-button"
          >
            Contact us directly
          </button>
        </li>
      </ul>
    </div>
  </aside>
);
